import React from "react";
import { Link } from "react-router-dom";
import NorthEastOutlinedIcon from "@mui/icons-material/NorthEastOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import RoomIcon from "@mui/icons-material/Room";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Footer = () => {
  return (
    <footer>
      <a
        href="https://wa.me/971501381984?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery%20in%20rent%20category."
        className="btn-whatsapp-rent btn-whatsapp"
        target="_blank"
      >
        <div className="appIcon btn-whatsapp-pulse btn-whatsapp-pulse-border">
          <WhatsAppIcon sx={{ color: "#fff", fontSize: "35px" }} />
        </div>
        <span>For Rent</span>
      </a>

      <a
        href="https://wa.me/971501501145?text=Hi,%20I'd%20like%20to%20learn%20more%20about%20your%20current%20current%20offers%20on%20heavy%20machinery%20in%20buy%20category."
        className="btn-whatsapp-buy btn-whatsapp"
        target="_blank"
      >
        <div className="appIcon btn-whatsapp-pulse btn-whatsapp-pulse-border">
          <WhatsAppIcon sx={{ color: "#fff", fontSize: "35px" }} />
        </div>
        <span>For Buy & Sale</span>
      </a>
      <div className="container">
        <div className="quote-box">
          <div className="qb-left">
            <h1>Let's Get In Touch!</h1>
            <p>
              Our mission is to provide high-quality equipment solutions that
              empower construction and industrial projects to succeed.
            </p>
          </div>

          <div className="qb-right">
            <Link to="/contact-us">
              Get Connected{" "}
              <NorthEastOutlinedIcon
                sx={{ fontSize: "20px", marginLeft: "7px" }}
              />
            </Link>
          </div>
        </div>

        <div className="footer-links mt-[3rem] pb-[3rem]">
          <div className="basis-[40%] mt-[2rem]">
            <h1 className="text-2xl text-white font-bold">Amin Grand Asia</h1>
            <p className="text-sm text-white mt-4 text-justify">
              Amin Grand Asia Construction Equipment and Machinery Trading LLC
              is a premier provider of heavy equipment solutions, specializing
              in mobile cranes, tower cranes, and more. We offer comprehensive
              services for trading, rental projects, and import/export, catering
              to the diverse needs of the construction industry.
            </p>
          </div>

          <div className="basis-[20%] mt-[2rem]">
            <h1 className="text-md text-white font-medium mb-4">
              Useful Links
            </h1>
            <ul className="flex flex-col gap-3">
              <Link
                to="/"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Homepage
              </Link>
              <Link
                to="/services"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Services
              </Link>
              <Link
                to="/productlists"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Our Products
              </Link>
              <Link
                to="/contact-us"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Connect with us
              </Link>
            </ul>
          </div>

          <div className="basis-[20%] mt-[2rem]">
            <h1 className="text-md text-white font-medium mb-4">Company</h1>
            <ul className="flex flex-col gap-3">
              <Link
                to="/about-us"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                About Us
              </Link>
              <Link
                to="/organizational-chart"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Organizational Chart
              </Link>
              <Link
                to="/contact-us"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Contact Us
              </Link>
              <Link
                to="/organizational-chart"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Our Team
              </Link>
            </ul>
          </div>

          <div className="basis-[20%] mt-[2rem]">
            <h1 className="text-md text-white font-medium mb-4">
              Terms & Conditions
            </h1>
            <ul className="flex flex-col gap-3">
              <Link
                to="/about-us"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Mission & Vision
              </Link>
              <Link
                to="/terms-conditions"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Terms & Conditions
              </Link>
              <Link
                to="/privacy-policy"
                className="text-[#e3e5e7] text-[15px] font-[400] transition-all hover:text-white"
              >
                Privacy Policy
              </Link>
            </ul>
          </div>
        </div>

        <div className="footer-addresss gap-5 pt-[3rem] pb-[3rem]">
          <div className="flex gap-3 items-center basis-[33.33%]">
            <div className="">
              <CallOutlinedIcon sx={{ color: "#fff", fontSize: "28px" }} />
            </div>
            <div className="">
              <p className="text-[15px] text-white mb-1">Tel</p>
              <p className="text-[15px] text-white">+971 4 323 6878</p>
              <p className="text-[15px] text-white">+971 50 150 1145</p>
              <p className="text-[15px] text-white">+971 50 138 1984</p>
            </div>
          </div>

          <div className="flex gap-3 items-center basis-[33.33%]">
            <div className="">
              <MailOutlineOutlinedIcon
                sx={{ color: "#fff", fontSize: "28px" }}
              />
            </div>
            <div className="">
              <p className="text-[15px] text-white mb-1">Mail</p>
              <p className="text-[15px] text-white">info@agacrane.com</p>
            </div>
          </div>

          <div className="flex gap-3 items-center basis-[33.33%]">
            <div className="">
              <RoomIcon sx={{ color: "#fff", fontSize: "28px" }} />
            </div>
            <div className="">
              <p className="text-[15px] text-white mb-1">Address</p>
              <p className="text-[15px] text-white">
                P.O. Box: 214313 03 13th Floor, Al Saqr business Tower Sheikh
                Zayed road Dubai UAE.
              </p>
              <p className="text-[15px] text-white">
                P.O. Box: 37700 Industrial Area 13, Opposite Adnoc near Bin
                Ladin Signal Al Aziz Building Sharjah UAE.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className=" bg-[#3578ef] py-4 px-7">
        <div className="container footer-addresss flex-er-gap justify-between items-center">
          <div className="text-sm text-white">
            Amin Grand Asia &copy; 2024, All Rights Reserved.
          </div>

          <div className="flex gap-2">
            <a href="#" target="_blank">
              <FacebookIcon sx={{ fontSize: "22px", color: "#fff" }} />
            </a>
            <a
              href="https://www.instagram.com/craneagacompany/profilecard/?igsh=MTE3NnYxMjkyaTNtOQ=="
              target="_blank"
            >
              <InstagramIcon sx={{ fontSize: "22px", color: "#fff" }} />
            </a>
            <a
              href="https://www.linkedin.com/in/crane-mousavi-91a2ba137?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
              target="_blank"
            >
              <LinkedInIcon sx={{ fontSize: "22px", color: "#fff" }} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
